import { createEvent } from 'effector';

/**
 * This event is required for Redux DevTools integration.
 * Redux DevTools shows empty state until this event gets fired
 */
export const effectorStartEvent = createEvent();
